// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-buttons[data-v-7fa44cff] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n.greyed[data-v-7fa44cff] {\n  color: var(--text-disabled);\n}\n.color-container[data-v-7fa44cff] {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
